// Pages
export const INDEX_PAGE_URL = '/';
export const HOME_PAGE_URL = '/lady-cinder';
export const REVIEWS_PAGE_URL = '/reviews';
export const SESSIONS_PAGE_URL = '/sessions';
export const GALLERY_PAGE_URL = '/gallery';
export const TRIBUTE_PAGE_URL = '/tribute';
export const FAQ_PAGE_URL = '/faq';
export const ABOUT_PAGE_URL = '/about-lady-cinder';
export const FANSITES_PAGE_URL = '/fansites';
export const DUNGEON_PAGE_URL = '/dungeon';
export const BOOKING_PAGE_URL = '/booking';
export const CONTACT_PAGE_URL = '/contact';
export const LOGIN_PAGE_URL = '/login';

// Terms and Conditions
export const POLICIES_PAGE_URL = '/user-agreements';

// Maintainance
export const MAINTENANCE_PAGE_URL = '/down-for-maintenance';

// Error
export const ERROR_404_PAGE_URL = '*';

// Admin pages
export const ADMIN_PAGE_URL = '/admin';
export const ADMIN_CONTACT_FORM_PAGE_URL = '/admin/contact-forms';

